// utils/apiFetch.js

import { alertas } from "../ui/alerts.js";

export function handleApiError(err, context = "") {

  console.error("API ERROR:", context, err);

  // 🌐 error de red / http2 / sin internet
  if (
    err?.name === "TypeError" ||
    err?.name === "AbortError" ||
    err?.message?.includes("Failed to fetch")
  ) {
    alertas({
      type: "warning",
      title: "Connection lost",
      message: "Please check your internet connection and try again."
    });
    return true; // ❌ cortar
  }

  // 🧯 JSON inválido
  if (err === "INVALID_JSON") {
    alertas({
      type: "error",
      title: "Server error",
      message: "Invalid server response"
    });
    return true;
  }

  // 🚫 error lógico backend
  if (typeof err === "string") {
    alertas({
      type: "error",
      title: "Error",
      message: err
    });
    return true;
  }

  return false;
}